(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/header-portal/components/user.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/header-portal/components/user.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const {
  LOGIN,
  COMPANY_DETAILS
} = svs.ticket_partner.constants.routes;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
svs.ticket_partner.sharedComponents.headerPortal.components.TEXTS = {
  LOGGED_IN: 'Inloggad',
  NOT_LOGGED_IN: 'Företagsinloggning'
};
const User = () => {
  const {
    LOGGED_IN,
    NOT_LOGGED_IN
  } = svs.ticket_partner.sharedComponents.headerPortal.components.TEXTS;
  const {
    isLoggedIn,
    companyDetailsPromise
  } = svs.ticket_partner.useUserContext();
  const [userTitle, setUserTitle] = useState(null);

  useEffect(async () => {
    if (isLoggedIn) {
      const {
        companyDetails
      } = await companyDetailsPromise;
      setUserTitle((companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.companyName) || LOGGED_IN);
    } else {
      setUserTitle(NOT_LOGGED_IN);
    }
  }, [isLoggedIn, companyDetailsPromise]);
  const handleOnClick = e => {
    e.preventDefault();
    const route = isLoggedIn ? COMPANY_DETAILS : LOGIN;
    location.href = "".concat(location.origin, "/").concat(svs.core.data.baseUrl + route);
  };
  return React.createElement(IconButton, {
    "aria-controls": "navigation-menu-user",
    className: "nav-user",
    onClick: handleOnClick
  }, React.createElement("span", {
    className: "nav-user-title"
  }, userTitle), React.createElement(Icon, {
    className: "icon icon-default",
    icon: "user"
  }));
};
svs.ticket_partner.sharedComponents.headerPortal.components.User = User;

 })(window);